module.exports = __webpack_public_path__ + "assets/img/Affiches_008.fdb8160d.jpg";